import { axiosInstance } from "../utils/axiosInstance";

export const GetMembershipList = async (id) => {
  return await axiosInstance.get(`membership${id ? `/${id}` : ""}`);
};

export const GetStateList = async (zone) => {
  return await axiosInstance.get(`state/${zone}`);
};

export const getUserDetails = async (id) => {
  return await axiosInstance.get(`get_user_details/${id}`);
};

export const GetMemberStatus = async (id, status, num, comment) => {
  if (status === "reject")
    return await axiosInstance.get(
      `member_status/${num}/${id}/${status}?comment=${comment}`
    );
  else return await axiosInstance.get(`member_status/${num}/${id}/${status}`);
};

export const checkRejectStatus = async (id, status, num) => {
  return await axiosInstance.get(`check_status/${num}/${id}/${status}`);
};

export const GetPaymentData = async (id, amt, type, coupon) => {
  let endpoint = `payment/${id}/${amt}/${type}`;
  if (coupon) endpoint = `payment/${id}/${amt}/${type}/${coupon}`;
  return await axiosInstance.get(endpoint);
};

export const GetOrderDetails = async (id) => {
  return await axiosInstance.get(`get_order_details/${id}`);
};

export const validateMemberDetailService = async (params) => {
  return await axiosInstance.get(`validate_membership`, { params });
};

export const uploadFileService = async (data) => {
  return await axiosInstance.post("file_upload", data);
};

export const GetReceiptData = async (id) => {
  return await axiosInstance.get(`order/${id}`);
};

export const DownloadReceiptFile = async (id) => {
  return await axiosInstance.get(`order/view/${id}`, {
    responseType: "blob",
  });
};

export const GetLastUpgradeData = async (id) => {
  return await axiosInstance.get(`user/application/${id}`);
};

export const updateExistingUserData = async (data) => {
  return await axiosInstance.post("user_clean_update", data);
};

export const markExistingUserData = async (data) => {
  return await axiosInstance.post("user_clean_update/ignore", data);
};

export const getApplicationDetails = async (app_id) => {
  return await axiosInstance.get(`getApplication/${app_id}`);
};
